var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-hint",class:[
        _vm.status && `text-color-${_vm.status}`
    ]},[_vm._v(_vm._s(_vm.hint))])
}
var staticRenderFns = []

export { render, staticRenderFns }